module.exports = __webpack_public_path__ + "img/icon_substitution.3ea04299.svg";